/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;

import {UiEvent} from "./UiEvent";
import {UiCommand} from "./UiCommand";
import {UiSubEvent} from "./UiSubEvent";
import {UiSubCommand} from "./UiSubCommand";
import {TeamAppsEvent} from "../modules/util/TeamAppsEvent";
import {UiComponentConfig} from "./UiComponentConfig";
import {UiCachedImageConfig} from "./UiCachedImageConfig";
import {UiPageDisplayMode} from "./UiPageDisplayMode";


export interface UiImageDisplayConfig extends UiComponentConfig {
	_type?: string;
	totalNumberOfRecords: number;
	cachedImages?: UiCachedImageConfig[];
	displayMode?: UiPageDisplayMode;
	zoomFactor?: number;
	backgroundColor?: string;
	padding?: number;
	loop?: boolean;
	cacheSize?: number
}

export interface UiImageDisplayCommandHandler {
	setCachedImages(startIndex: number, cachedImages: UiCachedImageConfig[], totalNumberOfRecords: number): void;
	setDisplayMode(displayMode: UiPageDisplayMode, zoomFactor: number): void;
	setZoomFactor(zoomFactor: number): void;
	showImage(id: string): void;
}

export interface UiImageDisplayEventSource {
	onImagesRequest: TeamAppsEvent<UiImageDisplay_ImagesRequestEvent>;
	onImageDisplayed: TeamAppsEvent<UiImageDisplay_ImageDisplayedEvent>;
}

export interface UiImageDisplay_ImagesRequestEvent extends UiEvent {
	_type: "UiImageDisplay.imagesRequest";
	redundancyKey?: string;
	startIndex: number;
	length: number
}

export interface UiImageDisplay_ImageDisplayedEvent extends UiEvent {
	_type: "UiImageDisplay.imageDisplayed";
	redundancyKey?: string;
	imageId: string
}

